export type CyberInsuranceInfoData = {
  title: string;
  description: string;
  coverageHeading: string;
  coverageItems: string[];
};

export const CYBER_INSURANCE_DATA: CyberInsuranceInfoData = {
  title: "Cyber insurance",
  description:
    "Cyber insurance can protect your business from the costs of claims involving stolen customer data, cyber attacks, breaches, and fraud.",
  coverageHeading: "What's covered",
  coverageItems: [
    "Data breaches",
    "Business disruption",
    "Fraud response expenses",
    "Public relations expenses",
    "Privacy regulation claims",
    "And more",
  ],
};
